import React, { useMemo } from 'react';
import * as d3 from 'd3-shape';

function PieGraph({ size, data, colors }) {
  const paths = useMemo(() => {
    const arcs = d3
      .pie()(data)
      .map(d =>
        d3.arc()({
          startAngle: d.startAngle,
          endAngle: d.endAngle,
          innerRadius: 75,
          outerRadius: 100
        })
      );

    return arcs.map((d, i) => {
      return <path key={i} d={d} id={i} style={{ fill: colors[i] }} />;
    });
  }, [colors, data]);

  return (
    <svg width={size} height={size}>
      <g transform={`translate(${size / 2},${size / 2})`}>{paths}</g>
    </svg>
  );
}

export default PieGraph;
